export default __webpack_public_path__ + "static/Litepaper - English-57ac8b8fcc07c4a847040ae427752067.pdf";